'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useEffect, useState} from 'react';
import styles from './install_popup.module.less';
import {Button} from '../../lib/button';
import {use_qs} from '../../lib/use_qs';
import {guess_os_and_version} from '../../client_hints_global';
import {use_browser} from '../../lib/use_browser';
import {img_url} from '../../ui/img_url';
import {perr} from 'hola_pub_util';
import {Svg_img} from '../../ui/svg_img';
import Arrow from '../../img/hola2023/colored_arrow.svg';
// @ts-ignore
import {App_context} from '../../context';

const apps = {
  vpn: 'VPN',
  browser: 'Browser',
};

const d_images = {
  chrome_windows: '_chrome', firefox_windows: '_firefox',
  opera_windows: '_opera', chrome_macos: '_chrome_mac',
  opera_macos: '_opera_mac', firefox_macos: '_firefox_mac',
  safari_macos: '_safari_mac',
};

export const Install_popup = ()=>{
    const {is_client} = useContext(App_context);
    if (!is_client)
      return;
    const [show_popup, set_show_popup] = useState(false);
    const {step, app} = use_qs();
    const {os} = guess_os_and_version();
    let b = use_browser();
    useEffect(()=>{
        if (step)
          set_show_popup(true);
          perr({id: 'www_after_install_popup_show'});
    }, [step]);
    const img_key = d_images[`${b}_${os}`] || os=='macos' && '_mac' || '';
    const exe_img = `after_download_installer${img_key}.svg`;
    const app_type = app && apps[app] || 'VPN';
    const title = `Hola ${app_type} Awaits -`
      + ` Let’s Unblock the Internet!`;
    const img_path:any = {
      backgroundImage: `url('${img_url('install_flow/' + exe_img)}')`
    };
    return <div>
      {show_popup && <div className={styles.top_popup}>
        <div className={styles.box}>
          <Svg_img
            id={'hola2023/icons/16/x_close.svg'}
            w={16}
            h={16}
            on_click={()=>{
              set_show_popup(false);
              perr({id: 'www_after_install_popup_show_dismiss'});
            }}
            cls={styles.close_btn}/>
          <div className={styles.box_content}>
            <div className={styles.box_content_title}>
              {title}</div>
            <div className={styles.box_body}>
              <div className={styles.img_wrapper}>
                <div className={styles.download_img} style={img_path}/></div>
              <div className={styles.box_body_rigth}>
                <div className={styles.box_body_rigth_title}>
                  Click the file now to finish installing Hola {app_type}.
                    </div>
                <div className={styles.subtitle}>
                  Browse faster and acces more with Hola {app_type} for {os}
                  </div>
                <Button caption={'Got it'} color='black' size="sm"
                  theme="hola2023"
                  cls={styles.install_btn}
                  on_click={()=>{
                    set_show_popup(false);
                  }}/></div></div>
                  </div>
            <Arrow className={styles.arrow}/>
          </div>
        </div>}
    </div>;
};
